import {get, type Writable, writable} from 'svelte/store';
import SingletonDependency from 'Lib/SingletonDependency';
import {Scenario} from 'Generated/RestClient.g';
import type {KeyOrderPair} from 'Lib/Models/Order';
import type {ColumnKey} from 'Pages/PublicationPage/Lib/ColumnKeys';
import type {ISupportsListSorting} from 'Pages/PublicationPage/Lib/ISupportsListSorting';

export default class PublicationListContext extends SingletonDependency implements ISupportsListSorting {
    public scenarioListObservable: Writable<Scenario[]> = writable(new Array<Scenario>());
    public listSortingObservable: Writable<KeyOrderPair<ColumnKey>[]> = writable([
        {key: 'createdAt', order: 'desc'},
    ]);
    public pendingUploadCountObservable: Writable<number> = writable(0);
    public scenarioIdForPasswordDialogObservable: Writable<string | undefined> = writable(undefined);
    public deletableScenarioObservable: Writable<Scenario | undefined> = writable(undefined);

    public get scenarioList(): Scenario[] {
        return get(this.scenarioListObservable);
    }

    public set scenarioList(scenarioList: Scenario[]) {
        this.scenarioListObservable.set(scenarioList);
    }

    public get listSorting(): KeyOrderPair<ColumnKey>[] {
        return get(this.listSortingObservable);
    }

    public set listSorting(scenarioListSorting: KeyOrderPair<ColumnKey>[]) {
        this.listSortingObservable.set(scenarioListSorting);
    }

    public get pendingUploadCount(): number {
        return get(this.pendingUploadCountObservable);
    }

    public set pendingUploadCount(pendingUploadCount: number) {
        this.pendingUploadCountObservable.set(Math.max(pendingUploadCount, 0));
    }

    public set scenarioIdForPasswordDialog(id: string) {
        this.scenarioIdForPasswordDialogObservable.set(id);
    }
}
